class SizeChart extends HTMLElement {
  constructor() {
    super();
    this.footSizeInput = this.querySelector(".foot-size");
    this.shoeSize = this.querySelector(".shoe-size");
    this.shoeSizeFooter = this.querySelector(".shoe-size__footer");
    this.calculatorResult = this.querySelector(".calculator-result");
    this.footMin = this.querySelector(".foot-min");
    this.footMax = this.querySelector(".foot-max");
  }

  connectedCallback() {
    this.footSizeInput.addEventListener(
      "input",
      this.calculateShoeSize.bind(this)
    );
  }

  calculateShoeSize() {
    let footSize = this.footSizeInput.value;
    let shoeSizeValue = shoeSizeChart.find(
      (size) => size.footMin <= footSize && size.footMax >= footSize
    );

    if (shoeSizeValue) {
      this.calculatorResult.classList.remove("hidden");
      this.shoeSize.innerHTML = shoeSizeValue.size;
      this.shoeSizeFooter.innerHTML = shoeSizeValue.size;
      this.footMin.innerHTML = shoeSizeValue.footMin;
      this.footMax.innerHTML = shoeSizeValue.footMax;
    } else {
      this.calculatorResult.classList.add("hidden");
      this.shoeSize.innerHTML = "";
      this.shoeSizeFooter.innerHTML = "";
      this.footMin.innerHTML = "";
      this.footMax.innerHTML = "";
    }
  }
}

customElements.define("size-chart", SizeChart);

// let footSizeInput = document.getElementById("foot-size");
// let shoeSize = document.getElementById("shoe-size");
// let shoeSizeFooter = document.getElementById("shoe-size__footer");
// let calculatorResult = document.querySelector(".calculator-result");
// let footMin = document.getElementById("foot-min");
// let footMax = document.getElementById("foot-max");

// footSizeInput.addEventListener("input", function () {
//   let footSize = footSizeInput.value;
//   let shoeSizeValue = shoeSizeChart.find(
//     (size) => size.footMin <= footSize && size.footMax >= footSize
//   );

//   if (shoeSizeValue) {
//     calculatorResult.classList.remove("hidden");
//     shoeSize.innerHTML = shoeSizeValue.size;
//     shoeSizeFooter.innerHTML = shoeSizeValue.size;
//     footMin.innerHTML = shoeSizeValue.footMin;
//     footMax.innerHTML = shoeSizeValue.footMax;
//   } else {
//     calculatorResult.classList.add("hidden");
//     shoeSize.innerHTML = "";
//     shoeSizeFooter.innerHTML = "";
//     footMin.innerHTML = "";
//     footMax.innerHTML = "";
//   }
// });

const shoeSizeChart = [
  {
    size: 18,
    footMin: 108,
    footMax: 113,
  },
  {
    size: 19,
    footMin: 114,
    footMax: 119,
  },
  {
    size: 20,
    footMin: 120,
    footMax: 125,
  },
  {
    size: 21,
    footMin: 126,
    footMax: 131,
  },
  {
    size: 22,
    footMin: 132,
    footMax: 137,
  },
  {
    size: 23,
    footMin: 138,
    footMax: 143,
  },
  {
    size: 24,
    footMin: 144,
    footMax: 149,
  },
  {
    size: 25,
    footMin: 150,
    footMax: 155,
  },
  {
    size: 26,
    footMin: 156,
    footMax: 161,
  },
  {
    size: 27,
    footMin: 162,
    footMax: 168,
  },
  {
    size: 28,
    footMin: 169,
    footMax: 174,
  },
  {
    size: 29,
    footMin: 175,
    footMax: 180,
  },
  {
    size: 30,
    footMin: 181,
    footMax: 187,
  },
  {
    size: 31,
    footMin: 188,
    footMax: 193,
  },
  {
    size: 32,
    footMin: 194,
    footMax: 200,
  },
  {
    size: 33,
    footMin: 201,
    footMax: 207,
  },
  {
    size: 34,
    footMin: 208,
    footMax: 213,
  },
  {
    size: 35,
    footMin: 214,
    footMax: 220,
  },
  {
    size: 36,
    footMin: 221,
    footMax: 227,
  },
  {
    size: 37,
    footMin: 228,
    footMax: 233,
  },
  {
    size: 38,
    footMin: 234,
    footMax: 240,
  },
  {
    size: 39,
    footMin: 241,
    footMax: 247,
  },
  {
    size: 40,
    footMin: 248,
    footMax: 253,
  },
  {
    size: 41,
    footMin: 254,
    footMax: 260,
  },
  {
    size: 42,
    footMin: 261,
    footMax: 267,
  },
  {
    size: 43,
    footMin: 268,
    footMax: 274,
  },
];
